var exports = {
  "mz": "CustomerStories__xWvvf5",
  "Ng": "CustomerStories__gridContent__ilCiSm",
  "z6": "CustomerStories__dividerColumn__bwdT7t",
  "DR": "CustomerStories__divider__L-xWwU",
  "M_": "CustomerStories__column__5ciDTE",
};

module.exports = exports;
